/**
 * tdesign v0.44.2
 * (c) 2022 tdesign
 * @license MIT
 */

import { _ as _slicedToArray } from '../_chunks/dep-784849f3.js';
import { _ as _typeof } from '../_chunks/dep-dfae10c3.js';
import { useCallback, useState, useEffect } from 'react';
import { d as debounce_1 } from '../_chunks/dep-407a3536.js';
import '../_chunks/dep-d6cc3db8.js';
import '../_chunks/dep-7a9656a6.js';
import '../_chunks/dep-f4495ac9.js';
import '../_chunks/dep-6c09308a.js';
import '../_chunks/dep-da112583.js';
import '../_chunks/dep-762fb0bd.js';
import '../_chunks/dep-4929b64e.js';
import '../_chunks/dep-1e4c771d.js';

function useWindowSize() {
  var validWindow = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object";
  var getSize = useCallback(function () {
    return {
      width: validWindow ? window.innerWidth : void 0,
      height: validWindow ? window.innerHeight : void 0
    };
  }, [validWindow]);
  var _useState = useState(getSize()),
    _useState2 = _slicedToArray(_useState, 2),
    size = _useState2[0],
    setSize = _useState2[1];
  useEffect(function () {
    function handleResize() {
      setSize(getSize());
    }
    var debounceResize = debounce_1(handleResize, 400);
    if (validWindow) {
      window.addEventListener("resize", debounceResize);
      return function () {
        window.removeEventListener("resize", debounceResize);
        debounceResize.cancel();
      };
    }
  }, [getSize, validWindow]);
  return size;
}

export { useWindowSize as default };
//# sourceMappingURL=useWindowSize.js.map
